/*
 * Authors: mariushirjanu
 * Created: 20/06/2022
 */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';

@Component({
  selector: 'included-orders-dialog',
  template: `
    <p class="triple-space-bottom">
      <faq-link faqCode="INCLUDED_ORDERS"></faq-link>
    </p>
    
    <report-wrapper
      reportId="37"
      [filters]="report.queryFilters"
      [visibleColumns]="report.visibleColumns"
      [permittedActions]="report.permittedActions"
      gridHeight="110px;.ui-layout-north;.ui-layout-resizer-north;p.triple-space-bottom"
      isInDialog="true"
      showActions="true"
      showOperations="true"
      (onActionExecuted)="onActionExecuted.emit()">
    </report-wrapper>
  `
})
export class IncludedOrdersDialogComponent implements OnInit {
  @Input() public title:string;
  @Input() public isInDialog:boolean;
  @Input() public companyCountryId:number;
  @Input() public invoiceId:number;
  @Output() public onActionExecuted:EventEmitter<void> = new EventEmitter<void>();
  public report:IObject;

  constructor(
  ) {
    /***/
  }

  public ngOnInit():void {
    this.report = {
      queryFilters: {
        Fhinvid: this.invoiceId,
        Declodt_FROM: '',
        Declodt_TO: '',
        Deinvok: '',
        Dech_ok: '',
        Decurce: 'INV'
      },
      visibleColumns: [
        'Fhinvnr',
        'Desprnm',
        'Decounm',
        'Deconti',
        'Decomnm',
        'Deordnr',
        'Depornr',
        'Decredt',
        'Declodt',
        'Debpref',
        'Totalfee',
        'Delamcm',
        'Delamcn',
        'Invoiceurl'
      ],
      permittedActions: [
        'MARK_AS_UNPAID'
      ]
    };
  }
}